module.exports = __webpack_public_path__ + "img/yp.73bbe17c.png";